import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { IconComponent } from '@app/tw-shared/components';
import { MenuButtonDirective, NavItemDirective } from '@app/tw-shared/directives';
import { TranslateModule } from '@ngx-translate/core';
import { NavItemAdminService } from '../../services';
import { NavItemAdminListComponent } from '../nav-item-admin-list/nav-item-admin-list.component';
import { BehaviorSubject } from 'rxjs';
import { DropdownOpenCloseService } from '@app/tw-shared/directives/dropdown-open-close/dropdown-open-close.service';

@Component({
    selector: 'app-nav-item-admin',
    imports: [CommonModule, IconComponent, TranslateModule, NavItemAdminListComponent, MenuButtonDirective, NavItemDirective],
    templateUrl: './nav-item-admin.component.html',
    styleUrl: './nav-item-admin.component.scss',
    providers: [
        NavItemAdminService,
        {
            provide: DropdownOpenCloseService,
            useFactory: () => new DropdownOpenCloseService('dropdown'),
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavItemAdminComponent {
    @Input({ required: true }) position: number;
    readonly hover$ = new BehaviorSubject<boolean>(false);

    private readonly navItemAdminService = inject(NavItemAdminService);
    private readonly dropdownOpenCloseService = inject(DropdownOpenCloseService);

    readonly open$ = this.dropdownOpenCloseService.openEvent$;
    readonly active$ = this.navItemAdminService.active$;
    readonly listId = this.navItemAdminService.listId;

    onMouseenter(event: MouseEvent) {
        event.preventDefault();
        this.hover$.next(true);
    }

    onMouseleave(event: MouseEvent) {
        event.preventDefault();
        this.hover$.next(false);
    }
}
